

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import {MdKeyboardArrowRight} from "react-icons/md"
import { useEffect, useState } from "react"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import locationData, { locationDat10CitySpecific, locationData10CitySpecificWithTowns } from "../../../../utils/locationData/locationOptions"
import { setIsDurationStrict, updateRoute } from "../../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"
import textFilterForNakliyeHesaplama from "../../../../helper/nakliyeHesaplama/textFilterForNakliyeHesaplama"


// InputLocCityTown.jsx içinde, bileşenin üstüne ekleyebilirsin
const normalizeTr = (s = "") => s.toLocaleLowerCase("tr");

const splitTokens = (q = "") =>
  normalizeTr(q).split(/[\/\s]+/).filter(Boolean);

// text içinde (orijinal büyük-küçük korunarak) tokens konumlarını bul
const getRanges = (text, tokens) => {
  const lower = normalizeTr(text);
  let ranges = [];
  tokens.forEach((tok) => {
    const t = normalizeTr(tok);
    if (!t) return;
    let from = 0;
    while (true) {
      const idx = lower.indexOf(t, from);
      if (idx === -1) break;
      ranges.push([idx, idx + t.length]);
      from = idx + t.length; // overlap istemiyorsan bu doğru
    }
  });
  // çakışan aralıkları birleştir
  ranges.sort((a, b) => a[0] - b[0]);
  const merged = [];
  for (const [s, e] of ranges) {
    if (!merged.length || s > merged[merged.length - 1][1]) {
      merged.push([s, e]);
    } else {
      merged[merged.length - 1][1] = Math.max(merged[merged.length - 1][1], e);
    }
  }
  return merged;
};

// JSX parçaları döner
const renderHighlighted = (text, query) => {
  if (!query) return text;
  const tokens = splitTokens(query);
  if (!tokens.length) return text;

  const ranges = getRanges(text, tokens);
  if (!ranges.length) return text;

  const out = [];
  let last = 0;
  ranges.forEach(([s, e], i) => {
    if (last < s) out.push(<span key={`n-${i}`}>{text.slice(last, s)}</span>);
    out.push(<u key={`h-${i}`}>{text.slice(s, e)}</u>);
    last = e;
  });
  if (last < text.length) out.push(<span key="n-end">{text.slice(last)}</span>);
  return out;
};


const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({theme}) => theme.mainTextColor};

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? theme.mainTextColor : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive ? theme.mainTextColor : theme.mainBorderColor};
        border-color: ${({showErrors}) => showErrors && "var(--color-red)"};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            color: ${({theme}) => theme.mainTextColor};
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            display: flex;

            u{
                text-decoration: underline;
                text-underline-offset: 1px;
                text-decoration-thickness: 1px;
            }

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }

`

const InputLocCityTown = ({data, isRequired, labelText, name, inputWidth, isFirst}) => {


    const [text, setText] = useState(data?.location)
    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)

    const [options, setOptions] = useState(isFirst ? locationData10CitySpecificWithTowns : locationData)

    //! her zaman state deki değeri al
    useEffect(() => {
        setText(data.location)
    },[data])

    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(!searchText){
            setOptions(isFirst ? locationData10CitySpecificWithTowns : locationData)
            // dispatch(handleActiveSelect(null))
        }

        else{
            const result = textFilterForNakliyeHesaplama(isFirst ? locationData10CitySpecificWithTowns : locationData, searchText, "location",)
            setOptions(result)
        }
        setText(searchText)
    }

    const handleOptionClick = (item) => {
        dispatch(handleActiveSelect(null))

        dispatch(setIsDurationStrict(false))
        
        dispatch(updateRoute({
            id: data.id,
            lat: item.lat,
            lng: item.lng,
            location: item.location,
            cityId: item.cityId,
            region: item.region,
            mernis: item?.mernis || item?.townId,                   
        }))
    }

  return (
    <Container value={text} radius={"5px"} isActive={activeSelect === name} inputWidth={inputWidth}>

        <input type="text" id={"text"} onChange={handleChange} value={text} name={"text"} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
{ options.map((item) => (
  <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
    {renderHighlighted(item.location, text)}
  </div>
)) }
                </div>
            }
    </Container>
  )
}

export default InputLocCityTown